<a *ngIf="type==='POINT'" class="ca-anchor" [id]="anchorId" [name]="anchorId"></a>

<a *ngIf="type==='LINK'" class="ca-anchor-link" [href]="'#'+anchorId" (click)="scrollIntoView();$event.preventDefault()"
	[style.margin]="margin">
	<ng-content></ng-content>
	<!-- <button mat-icon-button color="accent">
        <mat-icon>anchor</mat-icon>
    </button> -->
</a>
